// extracted by mini-css-extract-plugin
module.exports = {"content":"AccessDeniedPage-content","image":"AccessDeniedPage-image","title":"AccessDeniedPage-title","btn":"AccessDeniedPage-btn"};